import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './Security.css';

/** Appears 5 minutes before the 90-minute idle sign-out. */
export default function IdleWarningModal() {
  const { idleWarning, idleRemainingMs, staySignedIn, signOut } = useAuth();
  if (!idleWarning) return null;

  const totalS = Math.max(0, Math.round(idleRemainingMs / 1000));
  const mm = String(Math.floor(totalS / 60)).padStart(1, '0');
  const ss = String(totalS % 60).padStart(2, '0');

  return (
    <div className="sec-modal-overlay" role="presentation">
      <div className="sec-modal" role="alertdialog" aria-modal="true" aria-labelledby="idle-title">
        <div className="sec-modal-header">
          <h2 id="idle-title">Still there?</h2>
        </div>
        <p className="sec-desc">For your security, you will be signed out after 90 minutes without activity.</p>
        <div className="sec-idle-countdown" aria-live="polite">{mm}:{ss}</div>
        <div className="sec-actions">
          <button type="button" className="sec-btn sec-btn--primary" onClick={staySignedIn} autoFocus>
            Stay signed in
          </button>
          <button type="button" className="sec-btn sec-btn--secondary" onClick={signOut}>
            Sign out now
          </button>
        </div>
      </div>
    </div>
  );
}
